import * as React from 'react'
import { IntlProvider } from 'react-intl'
import { Props } from './settlementsState'
import { SettlementsOverview } from './settlementsWidgets'

export default (props: Props): JSX.Element => (
  <IntlProvider locale={window.Gites.locale}>
    <SettlementsOverview {...props} />
  </IntlProvider>
)
